/**
 * PD-25 feature flag.
 *
 * Default OFF — `<ScoutIframeMount>` renders `null` and SubAppPage falls back to
 * the pre-PD-25 placeholder behavior. Production-deploy rollout is a separate
 * Ops decision; this flag is the kill-switch.
 *
 * Reads `import.meta.env.VITE_PD25_SCOUT_MOUNT_ENABLED` when present (Vite); falls
 * back to `false` so unwired environments are safe-by-default per plan §8 R10.
 *
 * Test harness override: callers may pass an explicit `enabled` prop to the
 * `<ScoutIframeMount>` component bypassing this constant — tests use it.
 */
export const PD25_SCOUT_MOUNT_ENABLED: boolean = (() => {
  try {
    // Vite-style env access; guarded so unit tests under Vitest don't crash.
    const env = (import.meta as unknown as { env?: Record<string, string | undefined> }).env;
    const v = env?.VITE_PD25_SCOUT_MOUNT_ENABLED;
    if (typeof v === 'string') {
      return v.toLowerCase() === 'true' || v === '1';
    }
  } catch {
    // No-op: default-deny.
  }
  return false;
})();
